import React from "react";

export default function Pagination({ page = 1, pageSize = 20, total = 0, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / (pageSize || 1)));
  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div className="pagination">
      <button disabled={!canPrev} onClick={() => canPrev && onPageChange(page - 1)}>
        Prev
      </button>
      <span>
        Page {page} of {totalPages}
      </span>
      <button disabled={!canNext} onClick={() => canNext && onPageChange(page + 1)}>
        Next
      </button>
    </div>
  );
}
